module.exports = __webpack_public_path__ + "static/media/HCLogo.d77636fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/HCLogo.png
// module id = 38
// module chunks = 0